import { Component, Input } from '@angular/core';

import { MatDialog } from '@angular/material/dialog';

import { DialogSiteHelpPublicComponent } from '../dialog-site-help-public/dialog-site-help-public.component';
import { DialogSiteHelpSecureComponent } from '../dialog-site-help-secure/dialog-site-help-secure.component';
import { DialogPrivacyComponent } from '../dialog-privacy/dialog-privacy.component';
import { DialogLegalDisclaimerComponent } from '../dialog-legal-disclaimer/dialog-legal-disclaimer.component';
import { DialogSiteTourComponent } from '../dialog-site-tour/dialog-site-tour.component';

@Component({
  selector: 'cigna-footer-global',
  templateUrl: './footer-global.component.html',
  styleUrls: ['./footer-global.component.scss'],
})
export class FooterGlobalComponent {
  // eslint-disable-next-line @typescript-eslint/naming-convention
  @Input() loggedIn = false;
  @Input() isMedical = true;

  currentYear: string = new Date().getFullYear().toString();
  constructor(public dialog: MatDialog) {}

  openSiteHelpModal() {
    if (this.loggedIn) {
      this.dialog.open(DialogSiteHelpSecureComponent, {
        autoFocus: false,
        width: '800px',
      });
    } else {
      this.dialog.open(DialogSiteHelpPublicComponent, {
        autoFocus: false,
        width: '800px',
      });
    }
  }

  openPrivacyModal() {
    this.dialog.open(DialogPrivacyComponent, {
      autoFocus: false,
      width: '800px',
    });
  }

  openLegalDisclaimerModal() {
    this.dialog.open(DialogLegalDisclaimerComponent, {
      autoFocus: false,
      width: '800px',
    });
  }

  openSiteTourModal() {
    this.dialog.open(DialogSiteTourComponent, {
      autoFocus: false,
      width: '980px',
    });
  }
}
